import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Blankpage from "./blankpage";

export default function BlankRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="blankpage" replace />} />
      <Route path="blankpage" element={<Blankpage />} />
      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  );
}
